export const buildProvenance = { "commitHash": "5c4a006ad2ea360fc6bccb7aa7b1ba72ddf3f367", "branchName": "refs/heads/release/2024.2", "buildDate": "2024-06-13T03:42:14.097Z", "version": "2024.2.9220" };
